import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReset = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.7015 5.29292C13.3431 3.93459 11.4181 3.15125 9.30147 3.36792C6.24314 3.67625 3.72647 6.15959 3.38481 9.21792C2.92647 13.2596 6.05147 16.6679 9.99314 16.6679C12.6515 16.6679 14.9348 15.1096 16.0015 12.8679C16.2681 12.3096 15.8681 11.6679 15.2515 11.6679C14.9431 11.6679 14.6515 11.8346 14.5181 12.1096C13.5765 14.1346 11.3181 15.4179 8.85147 14.8679C7.00147 14.4596 5.50981 12.9513 5.11814 11.1013C4.41814 7.86792 6.87647 5.00125 9.99314 5.00125C11.3765 5.00125 12.6098 5.57625 13.5098 6.48459L12.2515 7.74292C11.7265 8.26792 12.0931 9.16792 12.8348 9.16792H15.8265C16.2848 9.16792 16.6598 8.79292 16.6598 8.33459V5.34292C16.6598 4.60125 15.7598 4.22625 15.2348 4.75125L14.7015 5.29292Z",
		fill: "currentColor"
	})
});
export default SvgReset;
